/**
 * The phone's words for the Map act and the pin (piece 35, *Maps and the pin*;
 * decisions 4201, 8320), kept beside the first release's words and spread into
 * the one string lookup. A word the web already says, such as Open in Maps over
 * the choice of app, Pin Here, Clear Pin and who pinned, is read from the web's
 * own key (`record.tile.openInMaps`, `location.pin.*`) and is not repeated here.
 */
export const MAPS_STRINGS = {
  'mobile.maps.section': 'Maps',
  'mobile.maps.map': 'Map',
  'mobile.maps.apple': 'Apple Maps',
  'mobile.maps.google': 'Google Maps',
  'mobile.maps.fromPin': 'The maps open at the pin, which leads the address.',
  'mobile.maps.fromAddress': 'The maps open at the address.',
  'mobile.maps.notOpened': 'The phone could not open the maps app.',
  'mobile.maps.deniedIos': 'Location permission was refused, and nothing was pinned. Allow it under Settings › Privacy & Security › Location Services for this app (Expo Go while testing), then try again.',
  'mobile.maps.deniedAndroid': 'Location permission was refused, and nothing was pinned. Allow it under Settings › Apps for this app (Expo Go while testing) › Permissions › Location, then try again.',
  'mobile.maps.unavailable': 'The phone could not tell where you are, and nothing was pinned. Step outside or turn on Location Services, then try again.',
  'mobile.maps.unreachable': 'The server did not answer, and the pin is as it was. Check the connection, then try again.',
  'mobile.maps.pinCleared': 'Pin cleared; the maps open at the address again.',
} as const;
